import "./App.css";
import React from "react";
import FormComp from "./components/FormComp";

function App() {
  return <div className="App">
    <FormComp/>
  </div>;
}

export default App;
